/**
 * NovelSprig 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * NovelSprig 品牌特定主题配置
 */
export const theme = {
  // 引用装饰线颜色 (NovelSprig 使用绿色调)
  quoteColor: 'rgba(0, 188, 126, 0.3)',
  // 开始阅读按钮背景
  startReadingBg: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
